"use client";

import { useOnetrustTrigger } from "@up/ui";

export function OneTrustTrigger() {
  useOnetrustTrigger();
  return null;
}
